import React, { useContext, createContext, useState } from "react";
import { subLinks } from "../components/navbar-footer-components/utils/subLinks";

const NavContext = createContext();

const NavProvider = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCallOpen, setIsCallOpen] = useState(false);
  const [page, setPage] = useState({
    page: "",
    subtitle: "",
    subtitleTwo: "",
    linksOne: [],
    linksTwo: [],
    articles: [],
  });

  const openNavbarMenu = (text) => {
    const page = subLinks.find((link) => link.page === text);
    setPage(page);
    setIsMenuOpen(true);
  };

  const closeNavbarMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <NavContext.Provider
      value={{
        isMenuOpen,
        page,
        openNavbarMenu,
        closeNavbarMenu,
        isCallOpen,
        setIsCallOpen,
      }}
    >
      {children}
    </NavContext.Provider>
  );
};

export const useNavContext = () => {
  return useContext(NavContext);
};

export { NavContext, NavProvider };
